export const defaultResponsive = {
  0: { items: 1 },
  750: { items: 2 },
  1070: { items: 3 },
  1370: { items: 4 },
  1700: { items: 5 },
  3000: { items: 6 },
}
